module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_pin--light-blue-235c29c09181cd2eff8768f623b79970.svg";